import { CoachPage as CoachPageInner } from '@/features/coach/CoachPage';

export function CoachPage() {
  return <CoachPageInner />;
}
